import * as yup from "yup";
import { ref } from "vue";
import SectionVZButton from "./Button.vue";
import SectionVZRating from "./Rating.vue";
import SectionVZFile from "./File.vue";
import SectionVZAttachements from "./Attachements.vue";
import SectionVZInput from "./Input.vue";
import SectionVZLabel from "./Label.vue";
import SectionVZRadioButton from "./RadioButton.vue";
import SectionVZParagraph from "./Paragraph.vue";
import SectionVZSwitchButton from "./SwitchButton.vue";
import SectionVZCheckbox from "./Checkbox.vue";
import SectionVZTextArea from "./TextArea.vue";
import QRCode from "./QRCode.vue";
import QRCodeValidate from "./QRCodeValidate.vue";
import BarCode from "./BarCode.vue";
import BarCodeValidate from "./BarCodeValidate.vue";
import SectionVZList from "./List.vue";
import { v4 as uuidv4 } from "uuid";
export interface ISectionRow {
  rowProp?: Record<string, any>;
  columns: ISectionColumn[];
  webId?: string | number | null;
  class?: string;
  dirty?: boolean;
  key: string;
  deleted?: boolean;
  rowOrder: number;
  rowSpan: number;
  formSectionId: number | string;
}
export interface ISectionColumn {
  attrs?: Record<string, any>;
  colSpan: number;
  rowSpan?: number;
  components: Component[];
  webId?: string | number | null;
  class?: string;
  dirty?: boolean;
  key: string;
}

export interface Component {
  component: any;
  name?: string;
  defaultValue?: any;
  attrs?: Record<string, any>;
  events?: Record<string, (...args: any[]) => void>;
  webId?: string | number | null;
  dirty?: boolean;
  key: string;
  controlId: string;
  isLinkable?: boolean;
  linkedLabelKey?: string;
  direction?: ComponentDiretion;
}

export enum DroppableComponent {
  BUTTON = "BUTTON",
  RATING = "RATING",
  FILE = "FILE",
  ATTACHEMENTS = "ATTACHEMENTS",
  TEXT_FIELD = "TEXT_FIELD",
  HIDDEN = "HIDDEN",
  PASSWORD_FIELD = "PASSWORD_FIELD",
  RADIO_BUTTON = "RADIO_BUTTON",
  PARAGRAPH = "PARAGRAPH",
  SWITCH_BUTTON = "SWITCH_BUTTON",
  CHECK_BOX = "CHECK_BOX",
  LIST = "LIST",
  TEXT_AREA = "TEXT_AREA",
  LABEL = "LABEL",
  DIVIDER = "DIVIDER",
  IMAGE = "IMAGE",
  DATE = "DATE",
  SIGNATURE = "SIGNATURE",
  TIMER = "TIMER",
  CAMERA = "CAMERA",
  LOOKUP = "LOOKUP",
  QR_CODE = "QR_CODE",
  QR_VALIDATOR = "QR_VALIDATOR",
  BAR_CODE = "BAR_CODE",
  BAR_VALIDATOR = "BAR_VALIDATOR",
}
export interface IDroppableComponent {
  id: string;
  type: DroppableComponent;
  label: string;
  icon: string;
  defaultValue?: string;
  cssClass: string;
  action: () => void;
  component: any;
  isLinkable?: boolean;
}

export function createYupSchema(schema, config) {
  const { id, validationType, validations = [] } = config;
  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  validations.forEach((validation) => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    validator = validator[type](...params);
  });
  schema[id] = validator;
  return schema;
}

export const droppableControls = ref<Array<IDroppableComponent>>([
  // {
  //   id: "add-button",
  //   type: DroppableComponent.BUTTON,
  //   label: "Button",
  //   icon: "bi-menu-button",
  //   defaultValue: "",
  //   cssClass: "btn btn-outline btn-outline-primary btn-active-light-primary ",
  //   action: () => {
  //     //TODO
  //   },
  //   component: SectionVZButton,
  //   isLinkable: true,
  // },
  {
    id: "add-rating",
    type: DroppableComponent.RATING,
    label: "Rating",
    icon: "bi-star-half",
    defaultValue: "",
    cssClass: "btn btn-outline btn-outline-primary btn-active-light-primary ",
    action: () => {
      //TODO
    },
    component: SectionVZRating,
    isLinkable: true,
  },
  {
    id: "add-file",
    type: DroppableComponent.FILE,
    label: "File",
    icon: "bi-file-earmark-arrow-up",
    defaultValue: "",
    cssClass: "btn btn-outline btn-outline-primary btn-active-light-primary ",
    action: () => {
      //TODO
    },
    component: SectionVZFile,
    isLinkable: true,
  },
  {
    id: "add-attachements",
    type: DroppableComponent.ATTACHEMENTS,
    label: "Attachements",
    icon: "bi-paperclip",
    defaultValue: "",
    cssClass: "btn btn-outline btn-outline-primary btn-active-light-primary ",
    action: () => {
      //TODO
    },
    component: SectionVZAttachements,
    isLinkable: true,
  },
  {
    id: "add-checkbox",
    type: DroppableComponent.CHECK_BOX,
    label: "Checkbox",
    icon: " bi-ui-checks",
    defaultValue: "",
    cssClass: "form-check-input",
    action: () => {
      //TODO
    },
    component: SectionVZCheckbox,
    isLinkable: true,
  },
  {
    id: "add-radiobutton",
    type: DroppableComponent.RADIO_BUTTON,
    label: "Radio Button",
    cssClass: "form-check-input",
    icon: "bi-ui-radios",
    defaultValue: "",
    action: () => {
      //TODO
    },
    component: SectionVZRadioButton,
    isLinkable: true,
  },
  {
    id: "add-paragraph",
    type: DroppableComponent.PARAGRAPH,
    label: "Paraghraph",
    cssClass: "",
    icon: "bi-text-paragraph",
    defaultValue: "",
    action: () => {
      //TODO
    },
    component: SectionVZParagraph,
    isLinkable: false,
  }, //SectionVZSwitchButton
  {
    id: "add-switchbutton",
    type: DroppableComponent.SWITCH_BUTTON,
    label: "Switch Button",
    cssClass: "",
    icon: "bi-toggle-on",
    defaultValue: "",
    action: () => {
      //TODO
    },
    component: SectionVZSwitchButton,
    isLinkable: true,
  },
  {
    id: "add-textbox",
    type: DroppableComponent.TEXT_FIELD,
    label: "Text Box",
    icon: "bi-input-cursor-text",
    cssClass: "form-control",
    defaultValue: "",
    action: () => {
      //TODO
    },
    component: SectionVZInput,
    isLinkable: true,
  },
  {
    id: "add-textarea",
    type: DroppableComponent.TEXT_AREA,
    label: "Textarea",
    icon: "bi-textarea-resize",
    cssClass: "form-control",
    defaultValue: "",
    action: () => {
      //TODO
    },
    component: SectionVZTextArea,
    isLinkable: true,
  },
  // {
  //   id: "add-selectbox",
  //   type: DroppableComponent.LIST,
  //   label: "Select Box",
  //   icon: "bi-card-checklist",
  //   cssClass: "form-select",
  //   action: () => {
  //     //TODO
  //   },
  //   component: SectionVZList,
  //   isLinkable: true,
  // },
  {
    id: "add-lookup",
    type: DroppableComponent.LOOKUP,
    label: "Select Box",
    icon: "bi bi-menu-down",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: true,
  },
  {
    id: "add-label",
    type: DroppableComponent.LABEL,
    label: "Text",
    icon: "bi-fonts",
    defaultValue: "",
    cssClass: "form-label fw-bold",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: false,
  },
  {
    id: "add-divider",
    type: DroppableComponent.DIVIDER,
    label: "Divider",
    icon: "bi bi-hr",
    defaultValue: "",
    cssClass: "form-label fw-bold",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: false,
  },
  {
    id: "add-image",
    type: DroppableComponent.IMAGE,
    label: "Image",
    icon: "bi-images",
    defaultValue: "",
    cssClass: "img-fluid",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: true,
  },
  {
    id: "add-date",
    type: DroppableComponent.DATE,
    label: "Date",
    icon: "bi-calendar",
    defaultValue: "",
    cssClass: "img-fluid",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: true,
  },
  {
    id: "add-signature",
    type: DroppableComponent.SIGNATURE,
    label: "Signature",
    icon: "bi bi-vector-pen",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: true,
  },
  {
    id: "add-timer",
    type: DroppableComponent.TIMER,
    label: "Timer",
    icon: "bi bi-stopwatch",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: true,
  },
  {
    id: "add-camera",
    type: DroppableComponent.CAMERA,
    label: "Camera",
    icon: "bi bi-camera-fill",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: SectionVZButton,
    isLinkable: true,
  },
  // {
  //   id: "add-hidden-field",
  //   type: DroppableComponent.HIDDEN,
  //   label: "Hidden Field",
  //   icon: "bi bi-eye-slash",
  //   defaultValue: "",
  //   cssClass: "form-control hidden-field",
  //   action: () => {
  //     //TODO
  //   },
  //   component: SectionVZButton,
  //   isLinkable: true,
  // },
  {
    id: "add-qr-code",
    type: DroppableComponent.QR_CODE,
    label: "QR Code",
    icon: "bi bi-qr-code-scan",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: QRCode,
    isLinkable: true,
  },
  {
    id: "add-qr-validate",
    type: DroppableComponent.QR_VALIDATOR,
    label: "QR Code Validator",
    icon: "bi bi-qr-code",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: QRCodeValidate,
    isLinkable: true,
  },
  {
    id: "add-bar_code",
    type: DroppableComponent.BAR_CODE,
    label: "Bar Code",
    icon: "bi bi-upc-scan",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: BarCode,
    isLinkable: true,
  },
  {
    id: "add-bar-code-validate",
    type: DroppableComponent.BAR_VALIDATOR,
    label: "Bar Code Validator",
    icon: "bi bi-upc",
    defaultValue: "",
    cssClass: "",
    action: () => {
      //TODO
    },
    component: BarCodeValidate,
    isLinkable: true,
  },
]);
export interface ISaveFormServer {
  deleted?: boolean;
  cssClass?: string;
  rowOrder: number;
  rowSpan: number;
  attrs?: FormSectionRowColumnAttributeModel[];
  columns: FormSectionRowColumnModel[];
  webId?: string | number | null;
  key: string;
  formSectionId: number | string;
}

export interface FormSectionRowColumnModel {
  deleted?: boolean;
  cssClass?: string;
  columnOrder: number;
  colSpan: number;
  rowSpan?: number;
  attrs?: FormSectionRowColumnAttributeModel[];
  components: FormSectionRowColumnComponentModel[];
  webId?: string | number | null;
  formSectionRowId?: string | number | null;
  key: string;
}

export interface FormSectionRowColumnComponentModel {
  controlId: string;
  deleted?: boolean;
  cssClass: string;
  component: string;
  defaultValue: string;
  points: string;
  valReference?: string;
  lookup?: string;
  text?: string;
  data?: string;
  row: number;
  col: number;
  controlType?: string;
  translation: string;
  sequence: number | string;
  name: string;
  webId?: string | number | null;
  attrs: FormSectionRowColumnAttributeModel[];
  formSectionRowColumnId?: string | number | null;
  key: string;
  linkedLabelKey?: string;
  direction?: ComponentDiretion;
}

export interface FormSectionRowColumnAttributeModel {
  deleted?: boolean;
  webId?: string | null;
  key: string;
  value: any;
  type: FormSectionRowColumnAttributeModelType;
}

export type FormSectionRowColumnAttributeModelType =
  | "ROW"
  | "COLUMN"
  | "Validation"
  | "COMPONENT"
  | "Generic";

export function isValidJson(item) {
  item = typeof item !== "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item !== null) {
    return true;
  }

  return false;
}
export interface IContextMenu {
  label: string;
  icon: string;
  items?: IContextMenuItem[];
  command?: (event?: any) => void;
}

export interface IContextMenuItem {
  label: string;
  icon: string;
  command: (event?: any) => void;
}

export interface propsSignatureComponent {
  isPreview: boolean;
}

export type TSIDEBAROPTIONS = "CONTROLS" | "SETTINGS" | "TEMPLATES";
export function transformComponentData(
  rowElement,
  columnElement,
  columnIndex,
  componentElement,
  compIndex
): FormSectionRowColumnComponentModel {
  const component = {
    webId: componentElement?.webId,
    controlId: componentElement.controlId,
    cssClass: componentElement?.attrs?.class,
    component: componentElement.component,
    formSectionRowColumnId: rowElement?.webId ?? null,
    defaultValue:
      componentElement?.defaultValue ??
      componentElement.attrs.imageId ??
      componentElement?.text ??
      componentElement?.attrs?.label,
    points: "",
    valReference: "",
    lookup:
      componentElement.component == "LOOKUP"
        ? componentElement?.attrs?.label
        : "",
    text: componentElement?.attrs?.label,
    data: "",
    row: rowElement.rowOrder,
    col: columnIndex,
    controlType: componentElement.component,
    translation: "English",
    sequence: compIndex,
    dirty: componentElement?.dirty ?? false,
    key: componentElement?.attrs?.id,
    name: componentElement.name ?? componentElement?.attrs?.name,
    linkedLabelKey: componentElement?.linkedLabelKey ?? null,
    direction: componentElement?.direction ?? null,
    attrs: [] as unknown as FormSectionRowColumnAttributeModel[],
  };
  if (componentElement.attrs) {
    const keys = Array.from(
      new Set(Object.keys(componentElement?.attrs).map((key: string) => key))
    ).filter((key) => key !== "style");
    keys.map((item) => {
      const attrValue =
        Array.isArray(componentElement?.attrs?.[item]) ||
        isValidJson(componentElement?.attrs?.[item])
          ? JSON.stringify(componentElement?.attrs?.[item])
          : componentElement?.attrs?.[item] ?? "";
      const element = {
        type: "ATTRIBUTE" as FormSectionRowColumnAttributeModelType,
        key: item,
        value: attrValue,
      };
      component.attrs.push(element);
      return element;
    }) as FormSectionRowColumnAttributeModel[];
    if (componentElement?.attrs?.style) {
      const styleKeys = Object.keys(componentElement?.attrs?.style);
      styleKeys.map((item) => {
        const element = {
          type: "ATTRIBUTE" as FormSectionRowColumnAttributeModelType,
          key: item,
          value: componentElement?.attrs?.style?.[item],
        };
        component.attrs.push(element);
        return element;
      }) as FormSectionRowColumnAttributeModel[];
    }
  }
  return component;
}

export function transformColumnData(
  rowElement,
  columnElement,
  columnIndex: number
): FormSectionRowColumnModel {
  const column = {
    columnOrder: columnIndex,
    colSpan: columnElement.colSpan,
    // rowSpan: columnElement.rowSpan,
    webId: columnElement?.webId ?? null,
    dirty: columnElement?.dirty ?? false,
    formSectionRowId: rowElement?.webId ?? null,
    cssClass: columnElement?.class ?? "",
    key: columnElement.key,
    attrs: [
      {
        type: "COLUMN" as FormSectionRowColumnAttributeModelType,
        key: "id",
        value: columnElement.key,
      },
    ],
    components: [] as unknown as FormSectionRowColumnComponentModel[],
  };
  if (columnElement.components.length > 0) {
    columnElement.components.forEach((componentElement, compIndex) => {
      const component = transformComponentData(
        rowElement,
        columnElement,
        columnIndex,
        componentElement,
        compIndex
      );
      column.components.push(component);
    });
  }
  return column;
}
export function transformRowData(rowElement, index: number): ISaveFormServer {
  const row = {
    rowOrder: index,
    rowSpan: 1,
    webId: rowElement?.webId ?? null,
    dirty: rowElement?.dirty ?? false,
    key: rowElement.key,
    formSectionId: rowElement.formSectionId ?? "",
    attrs: [
      {
        type: "ROW" as FormSectionRowColumnAttributeModelType,
        key: "id",
        value: rowElement.key,
        dirty: rowElement?.dirty ?? false,
      },
    ],
    columns: [] as unknown as FormSectionRowColumnModel[],
  };
  if (rowElement.columns.length > 0) {
    rowElement.columns.forEach((columnElement, columnIndex) => {
      const column = transformColumnData(
        rowElement,
        columnElement,
        columnIndex
      );
      row?.columns?.push(column);
    });
  }
  return row;
}

export interface IinProcessForm {
  webId: number;
  updateDate: string;
  createdDate: string;
  clientId: number;
  createdBy: string;
  updatedBy: string;
  createdById: number;
  updatedById: number;
  formSectionId: number;
  data: ISectionData;
  status: string;
  key: string;
}
export interface ISectionData {
  formSectionRowModels: ISaveFormServer[];
}

export type ComponentDiretion = "UP" | "DOWN" | "LEFT" | "RIGHT";

export enum EComponentDiretion {
  UP = "UP",
  DOWN = "DOWN",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export const ComponentDiretionOptions = [
  // {
  //   label: "Up",
  //   id: EComponentDiretion.UP,
  // },
  // {
  //   label: "Down",
  //   id: EComponentDiretion.DOWN,
  // },
  {
    label: "Left",
    id: EComponentDiretion.LEFT,
  },
  {
    label: "Right",
    id: EComponentDiretion.RIGHT,
  },
];

export function getUniqueKey() {
  return [...Array(8)].map(() => Math.random().toString(36)[2]).join("");
}

export function transformToTableRow(data, sectionId) {
  const conmponetOldKeysToNew: Array<{ oldKey: string; newKey: string }> = [];
  const formStructure: ISectionRow[] = [];
  data.forEach((rowElement) => {
    const row = {
      rowProp: {},
      columns: [] as ISectionColumn[],
      webId: null,
      key: uuidv4(),
      formSectionId: sectionId,
      rowOrder: rowElement?.rowOrder ?? 1,
      rowSpan: rowElement?.rowSpan ?? 1,
    };
    if (rowElement.columns && !rowElement.deleted) {
      rowElement.columns.forEach((colElement) => {
        const col = {
          attrs: {},
          colSpan: +colElement.colSpan,
          rowSpan: colElement.rowSpan,
          components: [] as Component[],
          webId: null,
          formSectionRowId: null,
          class: colElement?.cssClass ?? "",
          key: uuidv4(),
        };
        if (colElement.attrs && !colElement.deleted) {
          colElement.attrs.forEach((attr) => {
            if (!attr.deleted) {
              col.attrs[attr.key] = attr.value;
            }
          });
          col.attrs["id"] = col.key;
        }
        if (colElement.components && !colElement.deleted) {
          colElement.components.forEach((comp) => {
            const key = uuidv4();
            if (!comp.deleted) {
              const component = {
                attrs: {
                  label: comp.name,
                },
                webId: null,
                formSectionRowColumnId: null,
                component: comp.component,
                name: comp.name,
                key,
                direction: comp?.direction,
                linkedLabelKey: comp?.linkedLabelKey ?? "",
                controlId: `${comp.component}_${sectionId}_${getUniqueKey()}`,
              };

              if (comp.attrs && !comp.deleted) {
                comp.attrs.forEach((attr) => {
                  if (isValidJson(attr.value)) {
                    component.attrs[attr.key] = JSON.parse(attr.value);
                  } else {
                    component.attrs[attr.key] = attr.value;
                  }
                });
              }
              component.attrs["id"] = component.key;
              col.components.push(component);
              conmponetOldKeysToNew.push({
                oldKey: comp.key,
                newKey: key,
              });
            }
          });
        }
        row.columns.push(col);
      });
      // check in row if any component is linked to another component and it has conmponetOldKeysToNew oldKey, update it with new key
      row.columns.forEach((col) => {
        col.components.forEach((comp) => {
          if (comp.linkedLabelKey) {
            if (comp.linkedLabelKey) {
              const newKey = conmponetOldKeysToNew.find(
                (item) => item.oldKey === comp.linkedLabelKey
              );
              if (newKey) {
                comp.linkedLabelKey = newKey.newKey;
              }
            }
          }
        });
      });

      formStructure.push(row);
    }
  });
  return formStructure;
}
